export default "__VITE_ASSET__UIyGGE8H__"